import createjs from "createjs";
import '../pathseg'
import Box2D from '../box2d'

const map = (function (createjs, Box2D) {

    //.animation-position-helper
    var mainContainer;

    const ART_W = 428   
    const ART_H = 441



    var canvas1
    var stage
    var AdobeAn = {}
    var map;
    var rsc;
    var paused;

    var start2dSim;
    (function (cjs, an) {

        var p; // shortcut to reference prototypes
        var lib = {};
        var ss = {};
        var img = {};
        lib.ssMetadata = [
            {
                name: "kutapolong_atlas_",
                frames: [[0, 0, 855, 884], [857, 60, 49, 49], [902, 0, 16, 16], [857, 0, 43, 58]]
            }
];


        // symbols:



        (lib.CachedTexturedBitmap_1 = function () {
            this.initialize(ss["kutapolong_atlas_"]);
            this.gotoAndStop(0);
        }).prototype = p = new cjs.Sprite();



        (lib.CachedTexturedBitmap_2 = function () {
            this.initialize(ss["kutapolong_atlas_"]);
            this.gotoAndStop(1);
        }).prototype = p = new cjs.Sprite();



        (lib.CachedTexturedBitmap_3 = function () {
            this.initialize(img.CachedTexturedBitmap_3);
        }).prototype = p = new cjs.Bitmap();
        p.nominalBounds = new cjs.Rectangle(0, 0, 2299, 2299);


        (lib.CachedTexturedBitmap_4 = function () {
            this.initialize(ss["kutapolong_atlas_"]);
            this.gotoAndStop(2);
        }).prototype = p = new cjs.Sprite();



        (lib.CachedTexturedBitmap_5 = function () {
            this.initialize(ss["kutapolong_atlas_"]);
            this.gotoAndStop(3);
        }).prototype = p = new cjs.Sprite();
        // helper functions:

        function mc_symbol_clone() {
            var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
            clone.gotoAndStop(this.currentFrame);
            clone.paused = this.paused;
            clone.framerate = this.framerate;
            return clone;
        }

        function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
            var prototype = cjs.extend(symbol, cjs.MovieClip);
            prototype.clone = mc_symbol_clone;
            prototype.nominalBounds = nominalBounds;
            prototype.frameBounds = frameBounds;
            return prototype;
        }


        (lib.Symbol5 = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {});

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_5();
            this.instance.parent = this;
            this.instance.setTransform(-0.5, -0.5, 0.5, 0.5);

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        }).prototype = getMCSymbolPrototype(lib.Symbol5, new cjs.Rectangle(-0.5, -0.5, 21.5, 29), null);


        (lib.Symbol2 = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {});

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_3();
            this.instance.parent = this;
            this.instance.setTransform(0, 0, 0.1138, 0.1138);

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        }).prototype = getMCSymbolPrototype(lib.Symbol2, new cjs.Rectangle(0, 0, 261.7, 261.7), null);


        (lib.Oval = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {});

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_2();
            this.instance.parent = this;
            this.instance.setTransform(0, 0, 0.6512, 0.6512);

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        }).prototype = getMCSymbolPrototype(lib.Oval, new cjs.Rectangle(0, 0, 31.9, 31.9), null);


        (lib.Symbol4 = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {});

            // Layer_1
            this.instance = new lib.CachedTexturedBitmap_4();
            this.instance.parent = this;
            this.instance.setTransform(6.85, 6.85, 0.4167, 0.4167);

            this.instance_1 = new lib.Oval();
            this.instance_1.parent = this;
            this.instance_1.setTransform(10.25, 10.25, 0.6398, 0.6398, 0, 0, 0, 16, 16);
            this.instance_1.alpha = 0.1992;

            this.timeline.addTween(cjs.Tween.get({}).to({
                state: [{
                    t: this.instance_1
                }, {
                    t: this.instance
                }]
            }).wait(1));

        }).prototype = getMCSymbolPrototype(lib.Symbol4, new cjs.Rectangle(0, 0, 20.4, 20.4), null);


        // stage content:
        (lib.kutapolong = function (mode, startPosition, loop) {
            this.initialize(mode, startPosition, loop, {
                pin: 1,
                line: 45,
                shape: 147,
                hidePin: 236
            });

            // timeline functions:
            this.frame_0 = function () {
                this.stop();
            }
            this.frame_44 = function () {
                this.stop();
            }
            this.frame_146 = function () {
                this.stop();
            }
            this.frame_235 = function () {
                this.stop()
            }
            this.frame_253 = function () {
                this.stop()
            }

            // actions tween:
            this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(102).call(this.frame_146).wait(89).call(this.frame_235).wait(18).call(this.frame_253).wait(1));

            // Layer_1
            this.instance = new lib.Symbol5();
            this.instance.parent = this;
            this.instance.setTransform(133.15, 117.15, 1, 1, 0, 0, 0, 10.2, 14);
            this.instance._off = true;

            this.timeline.addTween(cjs.Tween.get(this.instance).wait(27).to({
                _off: false
            }, 0).to({
                y: 135.25
            }, 11).wait(1).to({
                y: 132.25
            }, 0).wait(1).to({
                y: 135.25
            }, 0).wait(1).to({
                y: 132.25
            }, 0).wait(1).to({
                y: 135.25
            }, 0).wait(1).to({
                y: 132.25
            }, 0).wait(1).to({
                y: 135.25
            }, 0).wait(191).to({
                y: 112.25,
                alpha: 0
            }, 18).wait(1));

            // Layer_1
            this.instance_1 = new lib.Symbol4();
            this.instance_1.parent = this;
            this.instance_1.setTransform(133.2, 147.95, 0.24, 0.24, 0, 0, 0, 10.4, 10.4);
            this.instance_1._off = true;

            this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1).to({
                _off: false
            }, 0).to({
                regX: 10.3,
                regY: 10.3,
                scaleX: 1.2,
                scaleY: 1.2
            }, 18).to({
                regX: 10.2,
                regY: 10.2,
                scaleX: 1,
                scaleY: 1,
                x: 133.15,
                y: 147.9
            }, 7).wait(209).to({
                alpha: 0
            }, 18).wait(1));

            // mask_idn (mask)
            var mask = new cjs.Shape();
            mask._off = true;
            var mask_graphics_45 = new cjs.Graphics().p("A5oXeMAAAgu8MAwxAAAIAAThIAAAAIAAbbg");
            var mask_graphics_46 = new cjs.Graphics().p("A5NXeMAAAgu8MAwxAAAIAAThIAAAAIAAbbg");
            var mask_graphics_47 = new cjs.Graphics().p("A4yXfMAAAgu9MAwxAAAIAAThIAAAAIAAbcg");
            var mask_graphics_48 = new cjs.Graphics().p("A4YXfMAAAgu9MAwwAAAIAAThIABAAIAAbcg");
            var mask_graphics_49 = new cjs.Graphics().p("A4YXfMAAAgu9MAwxAAAIAAThIAAAAIAAbcg");
            var mask_graphics_50 = new cjs.Graphics().p("A4YXfMAAAgu9MAwwAAAIAAThIABAAIAAbcg");
            var mask_graphics_51 = new cjs.Graphics().p("A4YXeMAAAgu7MAwxAAAIAATgIAAAAIAAbbg");
            var mask_graphics_52 = new cjs.Graphics().p("A4YXeMAAAgu7MAwwAAAIAATgIABAAIAAbbg");
            var mask_graphics_53 = new cjs.Graphics().p("A4YXeMAAAgu7MAwxAAAIAATgIAAAAIAAbbg");
            var mask_graphics_54 = new cjs.Graphics().p("A4YXfMAAAgu9MAwwAAAIAAThIABAAIAAbcg");
            var mask_graphics_55 = new cjs.Graphics().p("A4YXeMAAAgu8MAwxAAAIAAThIAAAAIAAbbg");
            var mask_graphics_56 = new cjs.Graphics().p("A4YXeMAAAgu8MAwxAAAIAAThIAAAAIAAbbg");
            var mask_graphics_57 = new cjs.Graphics().p("A4YXeMAAAgu8MAwwAAAIAAThIABAAIAAbbg");
            var mask_graphics_58 = new cjs.Graphics().p("A4YXfMAAAgu8MAwwAAAIAATgIABAAIAAbcg");
            var mask_graphics_59 = new cjs.Graphics().p("A4YXfMAAAgu8MAwxAAAIAATgIAAAAIAAbcg");
            var mask_graphics_60 = new cjs.Graphics().p("A4YXfMAAAgu8MAwwAAAIAATgIABAAIAAbcg");
            var mask_graphics_61 = new cjs.Graphics().p("A4YXeMAAAgu8MAwxAAAIAAThIAAAAIAAbbg");
            var mask_graphics_62 = new cjs.Graphics().p("A4YXeMAAAgu8MAwwAAAIAAThIABAAIAAbbg");
            var mask_graphics_63 = new cjs.Graphics().p("A4YXeMAAAgu8MAwwAAAIAAThIABAAIAAbbg");
            var mask_graphics_64 = new cjs.Graphics().p("A4YXeMAAAgu8MAwxAAAIAAThIAAAAIAAbbg");
            var mask_graphics_65 = new cjs.Graphics().p("A4YXfMAAAgu8MAwxAAAIAATgIAAAAIAAbcg");
            var mask_graphics_66 = new cjs.Graphics().p("A4YXfMAAAgu8MAwwAAAIAATgIABAAIAAbcg");
            var mask_graphics_67 = new cjs.Graphics().p("A4YXfMAAAgu8MAwxAAAIAATgIAAAAIAAbcg");
            var mask_graphics_68 = new cjs.Graphics().p("A4YXeMAAAgu8MAwwAAAIAAThIABAAIAAbbg");
            var mask_graphics_69 = new cjs.Graphics().p("A4YXeMAAAgu8MAwxAAAIAAThIAAAAIAAbbg");
            var mask_graphics_70 = new cjs.Graphics().p("A4YXeMAAAgu8MAwxAAAIAAThIAAAAIAAbbg");
            var mask_graphics_71 = new cjs.Graphics().p("A4YXeMAAAgu8MAwwAAAIAAThIABAAIAAbbg");
            var mask_graphics_72 = new cjs.Graphics().p("A4YXfMAAAgu8MAwxAAAIAATgIAAAAIAAbcg");
            var mask_graphics_73 = new cjs.Graphics().p("A4YXfMAAAgu8MAwwAAAIAATgIABAAIAAbcg");
            var mask_graphics_74 = new cjs.Graphics().p("A5QXfMAAAgu9MAygAAAIAAThIABAAIAAbcg");
            var mask_graphics_75 = new cjs.Graphics().p("A6IXfMAAAgu8MA0QAAAIAATgIABAAIAAbcg");
            var mask_graphics_76 = new cjs.Graphics().p("A7AXeMAAAgu8MA2AAAAIAAThIABAAIAAbbg");
            var mask_graphics_77 = new cjs.Graphics().p("A74XeMAAAgu8MA3wAAAIAAThIABAAIAAbbg");
            var mask_graphics_78 = new cjs.Graphics().p("A8vXeMAAAgu7MA5fAAAIAATgIAAAAIAAbbg");
            var mask_graphics_79 = new cjs.Graphics().p("A9nXeMAAAgu8MA7PAAAIAAThIAAAAIAAbbg");
            var mask_graphics_80 = new cjs.Graphics().p("A+fXeMAAAgu7MA8/AAAIAATgIAAAAIAAbbg");
            var mask_graphics_81 = new cjs.Graphics().p("A/XXfMAAAgu8MA+uAAAIAATgIABAAIAAbcg");
            var mask_graphics_82 = new cjs.Graphics().p("EggPAXfMAAAgu9MBAeAAAIAAThIABAAIAAbcg");
            var mask_graphics_83 = new cjs.Graphics().p("EghHAXfMAAAgu8MBCOAAAIAATgIABAAIAAbcg");
            var mask_graphics_84 = new cjs.Graphics().p("Egh/AXfMAAAgu9MBD+AAAIAAThIABAAIAAbcg");
            var mask_graphics_85 = new cjs.Graphics().p("Egi3AXeMAAAgu8MBFuAAAIAAThIABAAIAAbbg");
            var mask_graphics_86 = new cjs.Graphics().p("EgjuAXeMAAAgu8MBHdAAAIAAThIAAAAIAAbbg");
            var mask_graphics_87 = new cjs.Graphics().p("EgkmAXeMAAAgu8MBJNAAAIAAThIAAAAIAAbbg");
            var mask_graphics_88 = new cjs.Graphics().p("EgleAXeMAAAgu8MBK8AAAIAAThIABAAIAAbbg");
            var mask_graphics_89 = new cjs.Graphics().p("EgmWAXfMAAAgu8MBMsAAAIAATgIABAAIAAbcg");
            var mask_graphics_90 = new cjs.Graphics().p("EgnOAXfMAAAgu8MBOcAAAIAATgIABAAIAAbcg");
            var mask_graphics_91 = new cjs.Graphics().p("EgoGAXfMAAAgu8MBQMAAAIAATgIABAAIAAbcg");
            var mask_graphics_92 = new cjs.Graphics().p("Ego+AXfMAAAgu8MBR8AAAIAATgIABAAIAAbcg");
            var mask_graphics_93 = new cjs.Graphics().p("Egp2AXfMAAAgu9MBTsAAAIAAThIABAAIAAbcg");
            var mask_graphics_94 = new cjs.Graphics().p("EgquAXeMAAAgu8MBVcAAAIAAThIABAAIAAbbg");
            var mask_graphics_95 = new cjs.Graphics().p("EgrlAXfMAAAgu9MBXLAAAIAAThIAAAAIAAbcg");
            var mask_graphics_96 = new cjs.Graphics().p("EgsdAXeMAAAgu8MBY6AAAIAAThIABAAIAAbbg");
            var mask_graphics_97 = new cjs.Graphics().p("EgtVAXeMAAAgu7MBaqAAAIAATgIABAAIAAbbg");
            var mask_graphics_98 = new cjs.Graphics().p("Eg4sAXeMAAAgu8MBxYAAAIAAThIABAAIAAbbg");
            var mask_graphics_99 = new cjs.Graphics().p("Eg5JAW4MAA4gv1MBxbACGIgXT4IABAAIghb9g");
            var mask_graphics_100 = new cjs.Graphics().p("Eg5sAWFMAB9gwtMBxcAEkIg0UPIABAAIhJceg");
            var mask_graphics_101 = new cjs.Graphics().p("Eg6OAVRMADEgxjMBxZAHCIhSUmIACAAIhzc9g");
            var mask_graphics_102 = new cjs.Graphics().p("Eg6wAUcMAEOgyXMBxTAJfIhwU7IABAAIieddg");
            var mask_graphics_103 = new cjs.Graphics().p("Eg7RATnMAFagzLMBxJAL+IiQVQIABAAIjKd7g");
            var mask_graphics_104 = new cjs.Graphics().p("Eg7yASwMAGpgz7MBw8AObIixVlIABAAIj4eXg");
            var mask_graphics_105 = new cjs.Graphics().p("Eg8SAR5MAH6g0rMBwrAQ6IjSV4IABAAIkoezg");
            var mask_graphics_106 = new cjs.Graphics().p("Eg8xARBMAJMg1YMBwXATXIj0WKIABABIlYfNg");
            var mask_graphics_107 = new cjs.Graphics().p("Eg9QAQIMAKig2DMBv/AV0IkYWcIABABImKfmg");
            var mask_graphics_108 = new cjs.Graphics().p("Eg9uAPOMAL5g2sMBvkAYRIk8WtIABAAIm9f/g");
            var mask_graphics_109 = new cjs.Graphics().p("Eg+MAOTMANTg3SMBvGAasIliW+IABAAMgHxAgVg");
            var mask_graphics_110 = new cjs.Graphics().p("Eg+mANlMAOjg36MBuqAcxImDXOIABAAMgIfAgsg");
            var mask_graphics_111 = new cjs.Graphics().p("Eg/CAMpMAQAg4dMBuFAfMImpXcIABABMgJWAhAg");
            var mask_graphics_112 = new cjs.Graphics().p("Eg/eALsMARfg49MBteAhmInRXqIABAAMgKOAhTg");
            var mask_graphics_113 = new cjs.Graphics().p("Eg/5AKuMATBg5bMBsyAkAIn6X2IACABMgLHAhkg");
            var mask_graphics_114 = new cjs.Graphics().p("EhATAJvMAUjg52MBsEAmZIojYBIABABMgMAAh0g");
            var mask_graphics_115 = new cjs.Graphics().p("EhAsAIvMAWIg6OMBrRAowIpMYMIABAAMgM8AiDg");
            var mask_graphics_116 = new cjs.Graphics().p("EhBFAHuMAXvg6kMBqcArIIp3YVIABAAMgN4AiQg");
            var mask_graphics_117 = new cjs.Graphics().p("EhBcAGtMAZWg63MBpjAtdIqiYdIABAAMgO0Aibg");
            var mask_graphics_118 = new cjs.Graphics().p("EhBzAFrMAbAg7HMBonAvxIrOYkIABAAMgPyAikg");
            var mask_graphics_119 = new cjs.Graphics().p("EhCJAEoMAcrg7VMBnoAyFIr7YpIABABMgQwAisg");
            var mask_graphics_120 = new cjs.Graphics().p("EhCeADkMAeYg7fMBmlA0XIsoYuIABAAMgRwAiyg");
            var mask_graphics_121 = new cjs.Graphics().p("EhCyACuMAf6g7uMBlrA2TItRYzIABABMgSpAi6g");
            var mask_graphics_122 = new cjs.Graphics().p("EhDFABoMAhpg7yMBkiA4iIt+Y1IABABMgTrAi9g");
            var mask_graphics_123 = new cjs.Graphics().p("EhDXAAiMAjZg71MBjWA6xIutY2IABABMgUsAi/g");
            var mask_graphics_124 = new cjs.Graphics().p("EhDogAjMAlKg71MBiHA88IvcY3IABAAMgVuAi+g");
            var mask_graphics_125 = new cjs.Graphics().p("EhD5gBrMAm9g7xMBg2A/HIwMY1IABABMgWxAi8g");
            var mask_graphics_126 = new cjs.Graphics().p("EhEIgCzMAowg7pMBfhBBQIw8YyIABAAMgX0Ai3g");
            var mask_graphics_127 = new cjs.Graphics().p("EhEWgD8MAqkg7fMBeJBDYIxsYtIABABMgY4Aixg");
            var mask_graphics_128 = new cjs.Graphics().p("EhEjgFGMAsZg7RMBcuBFeIycYnIABABMgZ9Aipg");
            var mask_graphics_129 = new cjs.Graphics().p("EhEvgGRMAuPg6/MBbQBHhIzNYgIABABMgbCAifg");
            var mask_graphics_130 = new cjs.Graphics().p("EhE6gHcMAwFg6qMBZwBJiIz/YYIABABMgcGAiSg");
            var mask_graphics_131 = new cjs.Graphics().p("EhFDgIoMAx7g6SMBYMBLiI0wYOIABABMgdMAiEg");
            var mask_graphics_132 = new cjs.Graphics().p("EhFOgJmMAzng6CMBW2BNOI1dYHIABABMgeKAh7g");
            var mask_graphics_133 = new cjs.Graphics().p("EhFVgKzMA1eg5kMBVNBPKI2OX6IABABMgfQAhqg");
            var mask_graphics_134 = new cjs.Graphics().p("EhFbgMAMA3Wg5CMBThBRDI3AXsIABABMggWAhVg");
            var mask_graphics_135 = new cjs.Graphics().p("EhFggNPMA5Og4cMBRzBS6I3yXdIABABMghcAg/g");
            var mask_graphics_136 = new cjs.Graphics().p("EhFjgOeMA7Gg3zMBQBBUvI4jXMIABABMgijAgng");
            var mask_graphics_137 = new cjs.Graphics().p("EhFmgPtMA8+g3IMBOPBWiI5WW6IABABMgjoAgOg");
            var mask_graphics_138 = new cjs.Graphics().p("EhFmgQ9MA+1g2YMBMYBYSI6GWmIAAABMgkuAfyg");
            var mask_graphics_139 = new cjs.Graphics().p("EhFmgSOMBAtg1kMBKgBaAI65WQIABABMgl1AfUg");
            var mask_graphics_140 = new cjs.Graphics().p("EhFkgTfMBCkg0tMBIlBbrI7qV5IABABMgm7Ae0g");
            var mask_graphics_141 = new cjs.Graphics().p("EhFhgUxMBEbgzyMBGoBdUI8cVhIABABMgoAAeRg");
            var mask_graphics_142 = new cjs.Graphics().p("EhFcgWCMBGQgy1MBEpBe5I9NVIIABABMgpEAdtg");
            var mask_graphics_143 = new cjs.Graphics().p("EhFagXGMBH7gyCMBC6BgOI94UzIAAABMgqCAdPg");
            var mask_graphics_144 = new cjs.Graphics().p("EhFTgYZMBJwgw9MBA3BhvI+qUWIABABMgrHAcng");
            var mask_graphics_145 = new cjs.Graphics().p("EhFKgZsMBLlgv0MA+wBjMI/aT4IABABMgsLAb8g");
            var mask_graphics_146 = new cjs.Graphics().p("EhFGgbDMBNfgusMA8uBkxMggNATaIABABMgtSAbTg");

            this.timeline.addTween(cjs.Tween.get(mask).to({
                graphics: null,
                x: 0,
                y: 0
            }).wait(45).to({
                graphics: mask_graphics_45,
                x: -164.05,
                y: 5.3
            }).wait(1).to({
                graphics: mask_graphics_46,
                x: -161.375,
                y: 5.75
            }).wait(1).to({
                graphics: mask_graphics_47,
                x: -158.7,
                y: 6.25
            }).wait(1).to({
                graphics: mask_graphics_48,
                x: -155.95,
                y: 6.7
            }).wait(1).to({
                graphics: mask_graphics_49,
                x: -150.65,
                y: 7.15
            }).wait(1).to({
                graphics: mask_graphics_50,
                x: -145.3,
                y: 7.6
            }).wait(1).to({
                graphics: mask_graphics_51,
                x: -139.95,
                y: 8.1
            }).wait(1).to({
                graphics: mask_graphics_52,
                x: -134.6,
                y: 8.55
            }).wait(1).to({
                graphics: mask_graphics_53,
                x: -129.25,
                y: 9
            }).wait(1).to({
                graphics: mask_graphics_54,
                x: -123.9,
                y: 9.5
            }).wait(1).to({
                graphics: mask_graphics_55,
                x: -118.55,
                y: 9.95
            }).wait(1).to({
                graphics: mask_graphics_56,
                x: -113.25,
                y: 10.4
            }).wait(1).to({
                graphics: mask_graphics_57,
                x: -107.9,
                y: 10.85
            }).wait(1).to({
                graphics: mask_graphics_58,
                x: -102.55,
                y: 11.35
            }).wait(1).to({
                graphics: mask_graphics_59,
                x: -97.2,
                y: 11.8
            }).wait(1).to({
                graphics: mask_graphics_60,
                x: -91.85,
                y: 12.25
            }).wait(1).to({
                graphics: mask_graphics_61,
                x: -86.5,
                y: 12.75
            }).wait(1).to({
                graphics: mask_graphics_62,
                x: -81.15,
                y: 13.2
            }).wait(1).to({
                graphics: mask_graphics_63,
                x: -75.85,
                y: 13.65
            }).wait(1).to({
                graphics: mask_graphics_64,
                x: -70.5,
                y: 14.1
            }).wait(1).to({
                graphics: mask_graphics_65,
                x: -65.15,
                y: 14.6
            }).wait(1).to({
                graphics: mask_graphics_66,
                x: -59.8,
                y: 15.05
            }).wait(1).to({
                graphics: mask_graphics_67,
                x: -54.45,
                y: 15.5
            }).wait(1).to({
                graphics: mask_graphics_68,
                x: -49.1,
                y: 16
            }).wait(1).to({
                graphics: mask_graphics_69,
                x: -43.75,
                y: 16.45
            }).wait(1).to({
                graphics: mask_graphics_70,
                x: -38.45,
                y: 16.9
            }).wait(1).to({
                graphics: mask_graphics_71,
                x: -33.1,
                y: 17.35
            }).wait(1).to({
                graphics: mask_graphics_72,
                x: -27.75,
                y: 17.85
            }).wait(1).to({
                graphics: mask_graphics_73,
                x: -22.4,
                y: 18.3
            }).wait(1).to({
                graphics: mask_graphics_74,
                x: -15.7535,
                y: 18.5
            }).wait(1).to({
                graphics: mask_graphics_75,
                x: -9.107,
                y: 18.75
            }).wait(1).to({
                graphics: mask_graphics_76,
                x: -2.4588,
                y: 18.95
            }).wait(1).to({
                graphics: mask_graphics_77,
                x: 4.1377,
                y: 19.15
            }).wait(1).to({
                graphics: mask_graphics_78,
                x: 10.7842,
                y: 19.35
            }).wait(1).to({
                graphics: mask_graphics_79,
                x: 17.4308,
                y: 19.6
            }).wait(1).to({
                graphics: mask_graphics_80,
                x: 24.0773,
                y: 19.8
            }).wait(1).to({
                graphics: mask_graphics_81,
                x: 30.7238,
                y: 20
            }).wait(1).to({
                graphics: mask_graphics_82,
                x: 37.372,
                y: 20.2
            }).wait(1).to({
                graphics: mask_graphics_83,
                x: 43.9685,
                y: 20.45
            }).wait(1).to({
                graphics: mask_graphics_84,
                x: 50.615,
                y: 20.65
            }).wait(1).to({
                graphics: mask_graphics_85,
                x: 57.2615,
                y: 20.85
            }).wait(1).to({
                graphics: mask_graphics_86,
                x: 63.908,
                y: 21.05
            }).wait(1).to({
                graphics: mask_graphics_87,
                x: 70.5546,
                y: 21.3
            }).wait(1).to({
                graphics: mask_graphics_88,
                x: 77.2027,
                y: 21.5
            }).wait(1).to({
                graphics: mask_graphics_89,
                x: 83.7992,
                y: 21.7
            }).wait(1).to({
                graphics: mask_graphics_90,
                x: 90.4458,
                y: 21.9
            }).wait(1).to({
                graphics: mask_graphics_91,
                x: 97.0923,
                y: 22.15
            }).wait(1).to({
                graphics: mask_graphics_92,
                x: 103.7388,
                y: 22.35
            }).wait(1).to({
                graphics: mask_graphics_93,
                x: 110.3853,
                y: 22.55
            }).wait(1).to({
                graphics: mask_graphics_94,
                x: 117.0335,
                y: 22.75
            }).wait(1).to({
                graphics: mask_graphics_95,
                x: 123.63,
                y: 23
            }).wait(1).to({
                graphics: mask_graphics_96,
                x: 130.2765,
                y: 23.2
            }).wait(1).to({
                graphics: mask_graphics_97,
                x: 136.923,
                y: 23.4
            }).wait(1).to({
                graphics: mask_graphics_98,
                x: 223.3311,
                y: 26.15
            }).wait(1).to({
                graphics: mask_graphics_99,
                x: 222.7775,
                y: 26.4076
            }).wait(1).to({
                graphics: mask_graphics_100,
                x: 222.7886,
                y: 27.2733
            }).wait(1).to({
                graphics: mask_graphics_101,
                x: 222.8514,
                y: 28.3123
            }).wait(1).to({
                graphics: mask_graphics_102,
                x: 222.9595,
                y: 29.2826
            }).wait(1).to({
                graphics: mask_graphics_103,
                x: 223.0505,
                y: 30.477
            }).wait(1).to({
                graphics: mask_graphics_104,
                x: 223.1839,
                y: 31.7638
            }).wait(1).to({
                graphics: mask_graphics_105,
                x: 223.402,
                y: 33.1175
            }).wait(1).to({
                graphics: mask_graphics_106,
                x: 223.6109,
                y: 34.4611
            }).wait(1).to({
                graphics: mask_graphics_107,
                x: 223.7965,
                y: 35.9888
            }).wait(1).to({
                graphics: mask_graphics_108,
                x: 223.9635,
                y: 37.6001
            }).wait(1).to({
                graphics: mask_graphics_109,
                x: 224.2552,
                y: 39.2964
            }).wait(1).to({
                graphics: mask_graphics_110,
                x: 224.1517,
                y: 40.3686
            }).wait(1).to({
                graphics: mask_graphics_111,
                x: 224.5106,
                y: 42.3274
            }).wait(1).to({
                graphics: mask_graphics_112,
                x: 224.7877,
                y: 44.2699
            }).wait(1).to({
                graphics: mask_graphics_113,
                x: 225.1446,
                y: 46.4003
            }).wait(1).to({
                graphics: mask_graphics_114,
                x: 225.458,
                y: 48.621
            }).wait(1).to({
                graphics: mask_graphics_115,
                x: 225.8364,
                y: 50.9251
            }).wait(1).to({
                graphics: mask_graphics_116,
                x: 226.1858,
                y: 53.3783
            }).wait(1).to({
                graphics: mask_graphics_117,
                x: 226.5438,
                y: 55.8628
            }).wait(1).to({
                graphics: mask_graphics_118,
                x: 226.9031,
                y: 58.5851
            }).wait(1).to({
                graphics: mask_graphics_119,
                x: 227.22,
                y: 61.3437
            }).wait(1).to({
                graphics: mask_graphics_120,
                x: 227.5404,
                y: 64.2013
            }).wait(1).to({
                graphics: mask_graphics_121,
                x: 227.5769,
                y: 66.3307
            }).wait(1).to({
                graphics: mask_graphics_122,
                x: 227.909,
                y: 69.4105
            }).wait(1).to({
                graphics: mask_graphics_123,
                x: 228.0848,
                y: 72.5768
            }).wait(1).to({
                graphics: mask_graphics_124,
                x: 228.4558,
                y: 75.9755
            }).wait(1).to({
                graphics: mask_graphics_125,
                x: 228.6679,
                y: 79.3673
            }).wait(1).to({
                graphics: mask_graphics_126,
                x: 228.9113,
                y: 82.9478
            }).wait(1).to({
                graphics: mask_graphics_127,
                x: 229.0896,
                y: 86.6638
            }).wait(1).to({
                graphics: mask_graphics_128,
                x: 229.2979,
                y: 90.3759
            }).wait(1).to({
                graphics: mask_graphics_129,
                x: 229.3422,
                y: 94.3173
            }).wait(1).to({
                graphics: mask_graphics_130,
                x: 229.4563,
                y: 98.3423
            }).wait(1).to({
                graphics: mask_graphics_131,
                x: 229.4416,
                y: 102.5155
            }).wait(1).to({
                graphics: mask_graphics_132,
                x: 229.2093,
                y: 105.7746
            }).wait(1).to({
                graphics: mask_graphics_133,
                x: 229.2029,
                y: 110.151
            }).wait(1).to({
                graphics: mask_graphics_134,
                x: 229.0691,
                y: 114.6649
            }).wait(1).to({
                graphics: mask_graphics_135,
                x: 228.9361,
                y: 119.2076
            }).wait(1).to({
                graphics: mask_graphics_136,
                x: 228.6215,
                y: 123.9379
            }).wait(1).to({
                graphics: mask_graphics_137,
                x: 228.3635,
                y: 128.8432
            }).wait(1).to({
                graphics: mask_graphics_138,
                x: 227.9605,
                y: 133.7798
            }).wait(1).to({
                graphics: mask_graphics_139,
                x: 227.4594,
                y: 138.8457
            }).wait(1).to({
                graphics: mask_graphics_140,
                x: 226.949,
                y: 144.0359
            }).wait(1).to({
                graphics: mask_graphics_141,
                x: 226.2952,
                y: 149.4001
            }).wait(1).to({
                graphics: mask_graphics_142,
                x: 225.5795,
                y: 154.8331
            }).wait(1).to({
                graphics: mask_graphics_143,
                x: 224.8257,
                y: 159.2058
            }).wait(1).to({
                graphics: mask_graphics_144,
                x: 223.9623,
                y: 164.8762
            }).wait(1).to({
                graphics: mask_graphics_145,
                x: 223.0351,
                y: 170.5735
            }).wait(1).to({
                graphics: mask_graphics_146,
                x: 222.6275,
                y: 176.2541
            }).wait(108));

            // Layer_6
            this.instance_2 = new lib.CachedTexturedBitmap_1();
            this.instance_2.parent = this;
            this.instance_2.setTransform(0.35, -0.6, 0.5, 0.5);
            this.instance_2._off = true;

            var maskedShapeInstanceList = [this.instance_2];

            for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
                maskedShapeInstanceList[shapedInstanceItr].mask = mask;
            }

            this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(45).to({
                _off: false
            }, 0).wait(209));

            // mask_idn (mask)
            var mask_1 = new cjs.Shape();
            mask_1._off = true;
            var mask_1_graphics_147 = new cjs.Graphics().p("EAB5Ah+IhbnWQgBgIgGgFQgFgGgIgBIk0gzIi+lTQgDgFgEgDQgEgDgFgBIjQgxQgGgBgGABIi9AuIidhwIgskZQgCgJgHgGIjRi2QgFgEgFgBIizguQgFgBgGABQgFABgFAEIhYBBIjDhFQgFgCgGABIiqARIhfh0IAAleIB/lYIBJhKIEpCUQAEACAFAAQAFABAFgCIBpgmQAHgCAFgHQAEgGAAgIQAAgIgEgHIlKnTIDRiRIDRBAQAIACAJgDICmhDQAHgDAEgGQAEgHAAgHIAAlyIF0iYQAHgDAEgGQAEgHAAgHQABgIgEgGIiRjoIgVjCIAVjzIB7g5IBbAuQAHADAIgBQAJgCAFgGIBVhdIABgBIAfgnIDdCaQAEAEAGAAIKABnIEDB+IHmFDIACACIEPCNIDXDLQAFAFAIABIDiAfQAGABAGgCQAFgBAFgFIDzj0IBNBGIilD2QgGAJACAKIApDLIAALEIpUAuQgHAAgFAEQgGAEgDAGQgDAHABAHIAnFpIAAC1QAAAJAHAIQAGAHAJABIB2ARIAHAAIBmgPIBGCYIgyCnIiJCKIjnArQgHACgGAFQgFAGgCAIQgBAHADAHQADAHAHAEIBdA3IhNBRQgHAIAAAKIAACpIj8AVQgHABgGAFQgGAEgCAIIggBlIieAQQgJABgHAHIjRDqIkhAnQgJABgGAHQgHAHAAAKIAAEdg");

            this.timeline.addTween(cjs.Tween.get(mask_1).to({
                graphics: null,
                x: 0,
                y: 0
            }).wait(147).to({
                graphics: mask_1_graphics_147,
                x: 213.5125,
                y: 220.875
            }).wait(107));

            // Layer_4
            this.instance_3 = new lib.Symbol2();
            this.instance_3.parent = this;
            this.instance_3.setTransform(133.2, 147.95, 0.1188, 0.1188, 0, 0, 0, 130.8, 130.8);
            this.instance_3._off = true;

            var maskedShapeInstanceList = [this.instance_3];

            for (var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
                maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
            }

            this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(147).to({
                _off: false
            }, 0).to({
                regX: 130.6,
                regY: 130.6,
                scaleX: 4.3932,
                scaleY: 4.3932,
                x: 132.6,
                y: 155.05
            }, 88, cjs.Ease.cubicOut).wait(19));

        }).prototype = p = new cjs.MovieClip();
        p.nominalBounds = new cjs.Rectangle(0, 0, 427.9, 441.4);
        // library properties:
        lib.properties = {
            id: '1E425790439A4AD0BB931E93742EAA92',
            width: 600,
            height: 600,
            fps: 60,
            color: "#FFFFFF",
            opacity: 1.00,
            manifest: [
                {
                    src: "images/CachedTexturedBitmap_3.png?1588241352684",
                    id: "CachedTexturedBitmap_3"
                },
                {
                    src: "images/kutapolong_atlas_.png?1588241352641",
                    id: "kutapolong_atlas_"
                }
	],
            preloads: []
        };



        // bootstrap callback support:

        (lib.Stage = function (canvas) {
            createjs.Stage.call(this, canvas);
        }).prototype = p = new createjs.Stage();

        p.setAutoPlay = function (autoPlay) {
            this.tickEnabled = autoPlay;
        }
        p.play = function () {
            this.tickEnabled = true;
            this.getChildAt(0).gotoAndPlay(this.getTimelinePosition())
        }
        p.stop = function (ms) {
            if (ms) this.seek(ms);
            this.tickEnabled = false;
        }
        p.seek = function (ms) {
            this.tickEnabled = true;
            this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000);
        }
        p.getDuration = function () {
            return this.getChildAt(0).totalFrames / lib.properties.fps * 1000;
        }

        p.getTimelinePosition = function () {
            return this.getChildAt(0).currentFrame / lib.properties.fps * 1000;
        }

        an.bootcompsLoaded = an.bootcompsLoaded || [];
        if (!an.bootstrapListeners) {
            an.bootstrapListeners = [];
        }

        an.bootstrapCallback = function (fnCallback) {
            an.bootstrapListeners.push(fnCallback);
            if (an.bootcompsLoaded.length > 0) {
                for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
                    fnCallback(an.bootcompsLoaded[i]);
                }
            }
        };

        an.compositions = an.compositions || {};
        an.compositions['1E425790439A4AD0BB931E93742EAA92'] = {
            getStage: function () {
                return exportRoot.getStage();
            },
            getLibrary: function () {
                return lib;
            },
            getSpriteSheet: function () {
                return ss;
            },
            getImages: function () {
                return img;
            }
        };

        an.compositionLoaded = function (id) {
            an.bootcompsLoaded.push(id);
            for (var j = 0; j < an.bootstrapListeners.length; j++) {
                an.bootstrapListeners[j](id);
            }
        }

        an.getComposition = function (id) {
            return an.compositions[id];
        }





        an.makeResponsive = function (isResp, respDim, isScale, scaleType, domContainers) {
            var lastW, lastH, lastS = 1
            window.addEventListener('resize', resizeCanvas)
            resizeCanvas()
            rsc = resizeCanvas;

            function resizeCanvas() {
                var w = lib.properties.width,
                    h = lib.properties.height
                var iw = window.innerWidth,
                    ih = window.innerHeight
                var pRatio = window.devicePixelRatio || 1,
                    xRatio = iw / w,
                    yRatio = ih / h,
                    sRatio = 1
                if (isResp) {
                    if ((respDim == 'width' && lastW == iw) || (respDim == 'height' && lastH == ih)) {
                        sRatio = lastS
                    } else if (!isScale) {
                        if (iw < w || ih < h)
                            sRatio = Math.min(xRatio, yRatio)
                    } else if (scaleType == 1) {
                        sRatio = Math.min(xRatio, yRatio)
                    } else if (scaleType == 2) {
                        sRatio = Math.max(xRatio, yRatio)
                    }
                }


                ///////////////////////////
                ///////////////////////////


                var widthHelper = domContainers[1].parentElement
                var whw = widthHelper.offsetWidth
                sRatio = whw / ART_W



                domContainers[0].width = w * pRatio * sRatio
                domContainers[0].height = h * pRatio * sRatio
                domContainers.forEach(function (container) {
                    container.style.width = w * sRatio + 'px'
                    container.style.height = h * sRatio + 'px'
                })
                stage.scaleX = pRatio * sRatio
                stage.scaleY = pRatio * sRatio
                lastW = iw
                lastH = ih
                lastS = sRatio
                stage.tickOnUpdate = false
                stage.update()
                stage.tickOnUpdate = true

                
                   canvas1.style.height = 600 * sRatio/1.4 + 'px'
                canvas1.style.width = 600 * sRatio/1.4 + 'px'
              

                ///////////////////////////////////////////
                ///////////////////////////////////////////
                ///////////////////////////////////////////
                ///////////////////////////////////////////
                ///////////////////////////////////////////

                //REPOSITION

                //console.log(domContainers[1].parentElement.getBoundingClientRect().y,'>>')
                var y = window.innerHeight - ART_H * sRatio
                y /= 2
                    //var parentY=domContainers[1].parentElement.style.top
                var parentY = domContainers[1].parentElement.getBoundingClientRect().y
                y -= parentY
                    //animation-position-helper
                domContainers[1].style.top = y + "px";






            }
        }


    })(createjs, AdobeAn)

    let box = function () {

        var currentProgress = 0

   var path=[332.42, 633.21, 318.89, 563.03, 271.26, 555.2, 243.02, 504.87, 209.04, 496.97, 181.39, 503.64, 160.39, 488.54, 153.79, 446.89, 120.79, 418.28, 90.84, 410.58, 76.89, 421.07, 48.64, 411, 23.9, 413.51, 11.58, 398.47, 11.58, 349.09, 29.6, 300.03, 38.58, 290.98, 82.22, 312.67, 107.11, 303.77, 56.25, 231.83, 83.63, 212.85, 114.79, 222.29, 144.4, 210.33, 144.4, 154.37, 203.18, 130.31, 178.85, 91.27, 175.8, 63.84, 178.71, 30.44, 194.28, 23.26, 210.44, 31.36, 225.88, 14.38, 229.03, 10.32, 260.17, 32.15, 353.87, 47.05, 390.78, 64.99, 461.15, 111.95, 500.36, 132.37, 532.46, 162.68, 569.95, 167.9, 605.69, 132.17, 613.57, 139.39, 589.5, 175.26, 595.86, 206.9, 595.86, 306.72, 505.77, 313.66, 512.11, 372.26, 512.11, 403.27, 535.16, 406.63, 549.03, 404.65, 558.03, 424.16, 551.22, 446.82, 532.25, 465.87, 484.11, 474.82, 508.62, 489.35, 497.89, 500.74, 497.89, 525.4, 459.69, 528.66, 454.4, 545.61, 430.88, 547.97, 399.61, 582.83, 353.61, 589.08, 353.61, 633.21];
        var density = .1
        var force = .8
            // initial circles, doubled later
        var numCircles = (window.innerWidth< 500)? 100 : 300;
        var X = 3
        var Y = 5

        ////////////////////////////////////

        var MaxSpeed = force
        var doubling = false
        var creating = numCircles
        var exportRoot


        function init_(exportRoot_) {
            exportRoot = exportRoot_
                ///////////////////////////////////////////////// debug draw
            debugDraw = new b2DebugDraw()
                //debugDraw.SetSprite(document.getElementById('canvas1').getContext('2d'))
            debugDraw.SetSprite(canvas1.getContext('2d'))
            debugDraw.SetDrawScale(30.0*1.4)
            debugDraw.SetFillAlpha(0)

            debugDraw.SetAlpha(0)
                //debugDraw.SetLineThickness(0);
            debugDraw.SetFlags(b2DebugDraw.e_shapeBit | b2DebugDraw.e_jointBit)
            world.SetDebugDraw(debugDraw)
        }


        var b2Vec2 = Box2D.Common.Math.b2Vec2,
            b2AABB = Box2D.Collision.b2AABB,
            b2BodyDef = Box2D.Dynamics.b2BodyDef,
            b2Body = Box2D.Dynamics.b2Body,
            b2FixtureDef = Box2D.Dynamics.b2FixtureDef,
            b2Fixture = Box2D.Dynamics.b2Fixture,
            b2World = Box2D.Dynamics.b2World,
            b2MassData = Box2D.Collision.Shapes.b2MassData,
            b2PolygonShape = Box2D.Collision.Shapes.b2PolygonShape,
            b2CircleShape = Box2D.Collision.Shapes.b2CircleShape,
            b2EdgeChainDef = Box2D.Collision.Shapes.b2EdgeChainDef,
            b2DebugDraw = Box2D.Dynamics.b2DebugDraw,
            b2Color = Box2D.Common.b2Color,
            b2MouseJointDef = Box2D.Dynamics.Joints.b2MouseJointDef

        var world = new b2World(
            new b2Vec2(0, 0) //gravity
            , true //allow sleep
        )
        var debugDraw
        var fixDef = new b2FixtureDef

        fixDef.density = density
        fixDef.friction = 0
        fixDef.restitution = .999999

        var bodyDef = new b2BodyDef
        bodyDef.type = b2Body.b2_staticBody


        //////////////////////////////////////////////// walls

        fixDef.shape = new b2PolygonShape()
        for (var i = 0; i < path.length; i += 2) {

            var scale = .023

            if (i < (path.length - 2)) {
                var x0 = path[i] * scale
                var y0 = path[i + 1] * scale
                var x1 = path[i + 2] * scale
                var y1 = path[i + 3] * scale
            } else {
                var x0 = path[i] * scale
                var y0 = path[i + 1] * scale
                var j = i - (path.length - 2)

                var x1 = path[j + 0] * scale
                var y1 = path[j + 1] * scale


            }
            fixDef.shape.SetAsEdge(new b2Vec2(x0, y0), new b2Vec2(x1, y1))
            var b = world.CreateBody(bodyDef)
            b.CreateFixture(fixDef)
            b.wall = true
        }


        //////////////////////////////////////////////// contact
        var contactListener = new Box2D.Dynamics.b2ContactListener
        contactListener.BeginContact = function (contact) {
            var manifold = new Box2D.Collision.b2WorldManifold
            contact.GetWorldManifold(manifold)
            var contactPoint = manifold.m_points[0]
                //contactPoint=manifold.m_normal;


            var a = contact.GetFixtureA().GetBody()
            var b = contact.GetFixtureB().GetBody()

            var vel = b.GetLinearVelocity()
                //console.log(vel)
            var speed = vel.Normalize()
                //      console.log(vel,speed)

                 var mr=Math.random()
            if (mr > .99) {
                vel.Multiply(MaxSpeed + mr)
                b.SetLinearVelocity(vel)
            }
            // console.log(b.GetLinearVelocity())
            if (a.wall || b.wall) {

                if (a.wall) {

                    var force = .005
                    var ac = contactPoint
                    var bc = b.GetWorldCenter()

                    var dx = ac.x - bc.x
                    var dy = ac.y - bc.y


                    // b.ApplyImpulse(new b2Vec2(Math.random() * force - force / 2, Math.random() * force - force / 2), b.GetWorldCenter());
                    b.ApplyImpulse(new b2Vec2(dx * .01, dy * .01), b.GetWorldCenter())

                }


            } else {

                a.poison = b.poison || a.poison
                b.poison = b.poison || a.poison
            }


            // console.log("+")
            // if else statement here...

        }

        world.SetContactListener(contactListener)


        //   window.setInterval(update, 1000 / 60);


        bodyDef.type = b2Body.b2_dynamicBody
        fixDef.shape = new b2CircleShape(
                .08
            )
            //          bodyDef.position.x = X //Math.random() * 10;
            //          bodyDef.position.y = Y //Math.random() * 10;

        //////////////////////////////////////////////////////////// game tick

        function update(step) {
            if (paused) return
            if (creating > 0) {
                //create some objects

                for (var i = 0; i < 3; ++i) {
                    bodyDef.position.x = X + Math.random() * 3
                    bodyDef.position.y = Y + Math.random() * 3


                    var body = world.CreateBody(bodyDef)
                    body.CreateFixture(fixDef)
                    body.ApplyForce(new b2Vec2(Math.random() * force - force / 2, Math.random() * force - force / 2), body.GetWorldCenter())

                    creating--
                }

            }
            if (doubling) {
                //            for (b = world.m_bodyList; b; b = b.m_next) {
                //
                //
                //            }
                var body = world.m_bodyList

                while (body) {

                    var p = body.GetWorldCenter()

                    bodyDef.position.x = p.x
                    bodyDef.position.y = p.y


                    ///hack
                    if (p.x != 0) {

                        var b = world.CreateBody(bodyDef)
                        b.CreateFixture(fixDef)
                        b.ApplyForce(new b2Vec2(Math.random() * force - force / 2, Math.random() * force - force / 2), b.GetWorldCenter())
                    }
                    body = body.m_next


                }

                doubling = false

            }

            world.Step(1 / 60, 10, 10)
            world.DrawDebugData()
            world.ClearForces()

            window.requestAnimationFrame(update)
        }

        start2dSim = function () {
            window.requestAnimationFrame(update)
        }

        var vec, selectedBody

        function getBodyAtCP() {

            vec = new b2Vec2(X, Y)

            var aabb = new b2AABB()
            aabb.lowerBound.Set(X - 1, Y - 1)
            aabb.upperBound.Set(X + 1, Y + 1)

            // Query the world for overlapping shapes.

            selectedBody = null
            world.QueryAABB(getBodyCB, aabb)
            return selectedBody
        }

        function getBodyCB(fixture) {
            if (fixture.GetBody().GetType() != b2Body.b2_staticBody) {
                // if (fixture.GetShape().TestPoint(fixture.GetBody().GetTransform(), vec)) {
                selectedBody = fixture.GetBody()
                return false
                    //}
            }
            return true
        }


        function next_() {
            rsc();
            switch (currentProgress) {
            case 0:
                window.requestAnimationFrame(update)

                exportRoot.gotoAndPlay('pin')
                break

            case 1:
                exportRoot.gotoAndPlay('line')
                break

            case 2:
                exportRoot.gotoAndPlay('shape')
                break

            case 3:

                exportRoot.gotoAndPlay('hidePin')
                debugDraw.SetFillAlpha(1)
                break


            case 4:
                doubling = true
                break


            case 5:

                var b = getBodyAtCP()
                if (b) {
                    b.poison = true
                }
            }
            currentProgress++


        }

        world.DrawDebugData = function () {
            if (this.m_debugDraw == null) {
                return
            }
            this.m_debugDraw.m_sprite.graphics.clear()
            var flags = this.m_debugDraw.GetFlags()
            var i = 0
            var b
            var f
            var s
            var j
            var bp
            var invQ = new b2Vec2
            var x1 = new b2Vec2
            var x2 = new b2Vec2
            var xf
            var b1 = new b2AABB()
            var b2 = new b2AABB()
            var vs = [new b2Vec2(), new b2Vec2(), new b2Vec2(), new b2Vec2()]
            var color = new b2Color(0, 0, 0)
            if (flags & b2DebugDraw.e_shapeBit) {
                for (b = this.m_bodyList; b; b = b.m_next) {
                    xf = b.m_xf
                    for (f = b.GetFixtureList(); f; f = f.m_next) {
                        s = f.GetShape()

                        if (b.poison) {
                            color.Set(0.7725490196, 0.09019607843, 0.14117647058)
                            this.DrawShape(s, xf, color)
                        } else {
                            color.Set(0.40784313725 , 0.53333333333, 0.47058823529 )


                            this.DrawShape(s, xf, color)
                        }
                    }
                }
            }

        }

        return {
            next: function () {
                next_()
            },
            init: function (rut) {
                init_(rut)
            }
        }
    }()

    var map = function () {
        var canvas, exportRoot, anim_container, dom_overlay_container, fnStartAnimation
        var loadCompleted
        var initialised_
        var loaded_
        var promise_
        var comp

        var loader = new createjs.LoadQueue(false)

        promise_ = new Promise((resolve, reject) => {
            loader.addEventListener('complete', function (evt) {
                resolve(box.next)
                handleComplete(evt, comp)
            })
        })

        function init_(anim_containerParam, canvasParam, canvas1Param, dom_overlay_containerParam) {

            canvas = canvasParam
            canvas1 = canvas1Param
            anim_container = anim_containerParam
            dom_overlay_container = dom_overlay_containerParam
            comp = AdobeAn.getComposition('1E425790439A4AD0BB931E93742EAA92')
            var lib = comp.getLibrary()
                //var loader = new createjs.LoadQueue(false);
            loader.addEventListener('fileload', function (evt) {
                    handleFileLoad(evt, comp)
                })
                //        promise_ = new Promise((resolve, reject) => {
                //            loader.addEventListener("complete", function (evt) {
                //                resolve(box.next);
                //                handleComplete(evt, comp)
                //            });
                //        });
                //        loader.addEventListener("complete", function (evt) {
                //
                //            handleComplete(evt, comp)
                //        });
            var lib = comp.getLibrary()
            loader.loadManifest(lib.properties.manifest)
        }


        function handleFileLoad(evt, comp) {
            var images = comp.getImages()
            if (evt && (evt.item.type == 'image')) {
                images[evt.item.id] = evt.result
            }
        }

        function handleComplete(evt) {
            //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
            var lib = comp.getLibrary()
            var ss = comp.getSpriteSheet()
            var queue = evt.target
            var ssMetadata = lib.ssMetadata
            for (var i = 0; i < ssMetadata.length; i++) {
                ss[ssMetadata[i].name] = new createjs.SpriteSheet({
                    'images': [queue.getResult(ssMetadata[i].name)],
                    'frames': ssMetadata[i].frames
                })
            }
            exportRoot = new lib.kutapolong()
            stage = new lib.Stage(canvas)
                //Registers the "tick" event listener.
            fnStartAnimation = function () {
                    stage.addChild(exportRoot)
                    createjs.Ticker.setFPS(lib.properties.fps)
                    createjs.Ticker.addEventListener('tick', stage)
                }
                //Code to support hidpi screens and responsive scaling.
            AdobeAn.makeResponsive(true, 'both', false, 1, [canvas, anim_container, dom_overlay_container, canvas1])
            AdobeAn.compositionLoaded(lib.properties.id)
            fnStartAnimation()
            box.init(exportRoot)
            loadCompleted = true
        }

        function pause_(toPause) {
            toPause = toPause === undefined
            if (!loadCompleted) return;
            //            if(toPause){
            //                createjs.Ticker.removeEventListener('tick', stage);
            //            }else{
            //                createjs.Ticker.addEventListener('tick', stage);
            //                
            //            }
            rsc();
            paused = toPause;
            if (!paused)
                start2dSim();
        }

        return {
            pause: pause_,
            init: init_,
            ready: promise_

        }
    }()



    return map
})(createjs, Box2D, )

export default map;